if (!customElements.get("qr-code")) {
  customElements.define(
    "qr-code",
    class QrCode extends HTMLElement {
      constructor() {
        super();
        //console.log("qr code mounted");
      }

      connectedCallback() {
        //console.log(this.dataset.shareUrl)
        this.listItemId = this.closest('.product__media-item').id;
        this.container = this.querySelector(".qr-code");
        this.qrCode = this.querySelector("#qrcode");
        // Create a new QRCode instance with options
        if(!this.container) return;
        const qrCode = new QRCode(this.qrCode, {
          text: `${this.dataset.shareUrl}?viewModel=${this.listItemId}`, // URL or text you want to encode
          width: 160, // Width of the QR code
          height: 160, // Height of the QR code
          colorDark : "#000000", // Color of the dark squares
          colorLight : "#ffffff", // Color of the light squares
          correctLevel : QRCode.CorrectLevel.H // Error correction level (H is highest)
        });

        // You can also change the QR code content later by calling:
        // qrCode.makeCode("new content");

        // Add a class to the qr-code component once the QR code is generated
        this.classList.add("is-active");
        this.container.style.display = '';
      }
    }
  );
}
